
export default async function PhoneValidation(phone) {
	return /^\d{10}$/.test(phone);
	// return phoneNumberPattern.test(phone);
}
